import bs from './Bs/Config';
import bsEn from './BsEn/Config';

export default {
  ...bs,
  ...bsEn,
};
